var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSatNav24 = function SvgSatNav24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7.72 17.92a8.69 8.69 0 0 1-3.97-4.07 8 8 0 0 1-.46-5.5 8.46 8.46 0 0 1 3.24-4.6A9.38 9.38 0 0 1 12.09 2c2.01.02 3.96.67 5.53 1.85a8.43 8.43 0 0 1 3.14 4.67 8.01 8.01 0 0 1-.59 5.5A8.72 8.72 0 0 1 16.12 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m12.16 10.18 5.8 11.3a.35.35 0 0 1-.08.42.36.36 0 0 1-.43.05l-5.62-3.36-5.27 3.33a.37.37 0 0 1-.55-.23.35.35 0 0 1 .02-.23l5.5-11.27a.36.36 0 0 1 .31-.19.37.37 0 0 1 .32.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m15 7.5 4.5 7.5M9 7.5 4.5 15M4 7h16"
  })));
};
export default SvgSatNav24;